module.exports = __webpack_public_path__ + "static/media/viviendas2.e192c305.webp";